import { useEffect } from "react";

function scrollToFragment(hash: string) {
  const elementId = hash.slice(1); // Strip leading # symbol
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: "instant", block: "start" });
  }
}

// TODO: Move to AppKit
export function useScrollToFragment() {
  useEffect(() => {
    const hash = window.location.hash;

    if (!hash) {
      return;
    }

    scrollToFragment(hash);
  }, []);
}
